'use client';

import { BackNavigationBar, ShareButton } from '@/components';
import { useScroll } from '@vuddy/components';

interface IGachaPageNavigationBarProps {
  name?: string;
}

export const GachaPageNavigationBar = ({
  name,
}: IGachaPageNavigationBarProps) => {
  const [scroll] = useScroll();
  const isTop = scroll.y === 0;

  return (
    <BackNavigationBar
      backgroundColor={isTop ? 'whiteTransparent' : 'black'}
      iconColor="whitePrimary"
      color="whitePrimary"
      title={isTop ? '' : name}
      right={<ShareButton shareTitle={name} iconColor="whitePrimary" />}
    />
  );
};
